import { NewBookV1 } from '@ilteducation/content-registry-types';
import { DateTime } from 'luxon';

type GoogleBooksVolume = {
  volumeInfo: {
    title: string;
    subtitle: string;
    authors: [string];
    publisher: string;
    publishedDate: string;
    description: string;
    industryIdentifiers: [
      {
        type: string;
        identifier: string;
      },
    ];
    dimensions: {
      height: string;
      width: string;
      thickness: string;
    };
    printType: string;
    mainCategory: string;
    categories: [string];
    contentVersion: string;
    language: string;
    previewLink: string;
    infoLink: string;
    canonicalVolumeLink: string;
    pageCount: number;
  };
};

type GoogleBooksVolumesSearchResponse = {
  kind: string;
  totalItems: number;
  items: GoogleBooksVolume[];
};

/**
 * Sometimes the published date is a full date, sometimes it's just a year.
 * @param publishedDate
 */
const parsePublishYear = (publishedDate: string) => {
  if (!publishedDate) {
    return '';
  }

  const dateTime = DateTime.fromISO(publishedDate);

  const parsedYear = dateTime.year;

  if (Number.isNaN(parsedYear)) {
    return '';
  }

  return parsedYear.toString();
};

const parseName = (fullName: string) => {
  const parts = fullName.split(' ');
  return {
    firstName: parts.slice(0, -1).join(' '),
    lastName: parts[parts.length - 1],
  };
};

export const fetchGoogleBooksMetadata = async (isbn: string): Promise<Partial<NewBookV1> | null> => {
  const response = await fetch(`https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}`);
  const data = (await response.json()) as GoogleBooksVolumesSearchResponse;

  if (!data.totalItems) {
    return null;
  }

  const item = data.items[0];

  const { firstName: authorFirstName, lastName: authorLastName } = parseName(item.volumeInfo.authors[0]);

  const publishYear = parsePublishYear(item.volumeInfo.publishedDate);

  return {
    title: item.volumeInfo.title,
    description: item.volumeInfo.description,
    authors: [
      {
        firstName: authorFirstName,
        lastName: authorLastName,
      },
    ],
    pages: item.volumeInfo.pageCount,
    /**
     * Publish year should be a string e.g. '1998'
     */
    publishYear,
  };
};
